import {
  DayOfWeek,
  WorkScheduleDayModel,
} from '../../../../../shared/store/attendance/work-schedule/types';

/**
 * Display order of the week, Monday first (fr-FR). The back only rotates the days it returns; the
 * screens show all seven of them, so the order is fixed here.
 */
export const WEEK_DAYS: DayOfWeek[] = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

/** i18n key of a day label: 'Monday' → 'GLOBAL_LBL_DAY_OF_WEEK_MONDAY'. */
export const dayOfWeekLabelKey = (dayOfWeek: DayOfWeek): string =>
  `GLOBAL_LBL_DAY_OF_WEEK_${dayOfWeek.toUpperCase()}`;

/** "HH:mm" or "HH:mm:ss" (wall-clock time) → minutes since midnight. */
export const toMinutes = (time: string): number => {
  const [hours, minutes] = time.split(':');
  return +hours * 60 + +minutes;
};

/** Minutes → "9 h 05". */
export const formatDuration = (minutes: number): string =>
  `${Math.floor(minutes / 60)} h ${(minutes % 60).toString().padStart(2, '0')}`;

/**
 * Span of a day in minutes, from start to end. There is no break in the model, so this is an
 * amplitude, not worked time. 0 when a time is missing or the end is not after the start.
 */
export const dayAmplitude = (
  day: Pick<WorkScheduleDayModel, 'startTime' | 'endTime'>,
): number => {
  if (!day.startTime || !day.endTime) return 0;
  return Math.max(0, toMinutes(day.endTime) - toMinutes(day.startTime));
};
